import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactModal from 'react-modal';
import { Link, useNavigate } from 'react-router-dom';
import Sidebar from './components/Sidebar';
import Header from './components/Header';
import useAppLayout from './hooks/useAppLayout';
import API_URL from './api/config';

function VerifyInvitationInfoUpdate() {
  const { menu, toggleMobileMenu } = useAppLayout();
  
  const loggedInUserId = localStorage.getItem("user_id");
    const loggedFamilyAdmin = localStorage.getItem("family_admin");
    const navigate = useNavigate();
  const queryClient = useQueryClient();


  const {
    data: detailedFamily,
    isLoading: isDetailedLoading,
    isError: isDetailedError,
  } = useQuery({
    queryKey: ['familyDetails'],
    queryFn: async () => {
      const res = await axios.get(
        `${API_URL}/register-family-details-api`,
        { withCredentials: true }
      );
      return res.data;
    },
    staleTime: 0,
    cacheTime: Infinity,
  });


  
const [isSubmitting, setIsSubmitting] = useState(false);

const handleSubmit = (e) => {
  e.preventDefault();

   
};

  return (
    <div className={`main-wrapper ${menu ? 'slide-nav': ''}`}>
            <Header onMenuClick={(value) => toggleMobileMenu()} />
            <Sidebar />
        <ToastContainer />

        <div className='page-wrapper'>
          <div className='content container-fluid'>

        <div className="row justify-content-center">
                    <div className="col-12 col-lg-8 col-xl-7">
                      {/* ✅ remove overflow-hidden (it can clip dropdowns) */}
                      <div className="card shadow-sm border-0 rounded-4">
                        {/* ✅ smaller header */}
                        <div
                          className="px-3 py-3"
                          style={{
                            background:
                              "linear-gradient(135deg, rgba(116,186,84,0.18), rgba(44,83,61,0.06))",
                            borderBottom: "1px solid rgba(44,83,61,0.12)",
                          }}
                        >
                          <div className="d-flex align-items-start justify-content-between flex-wrap gap-2">
                            <div>
                              <h5 className="mb-1 fw-bold">Confirm Your Family Info</h5>
                            </div>
        
                            <div className="text-end">
                              <div
                                className="badge px-3 py-2 rounded-pill"
                                style={{
                                  background: "rgba(116,186,84,0.18)",
                                  color: "#2C533D",
                                  border: "1px solid rgba(44,83,61,0.18)",
                                }}
                              >
                                Step 1 of 2
                              </div>
                            </div>
                          </div>
        
                          <div className="mt-2">
                            <div className="progress" style={{ height: 7, borderRadius: 999, background: "rgba(44,83,61,0.12)" }}>
                              <div
                                className="progress-bar"
                                role="progressbar"
                                style={{ width: "50%", background: "linear-gradient(90deg, #74BA54, #2C533D)" }}
                              />
                            </div>
                          </div>
                        </div>
        
                        {/* ✅ smaller body, extra bottom space so browser has room to open dropdown DOWN */}
                        <div
                          className="card-body p-3 p-md-4"
                          style={{
                            paddingBottom: 28, // helps dropdown have space below
                          }}
                        >
                      
                         
        
        <div className="row">
          {isDetailedLoading && (
            <div className="card-body text-center py-5">
              <div className="spinner-border text-primary" role="status"></div>
              <p className="mt-2 text-muted">Loading lineage details...</p>
            </div>
          )}
        
          {isDetailedError && (
            <div className="alert alert-danger m-3" role="alert">
              Error loading family details. Please try again.
            </div>
          )}
        
          {detailedFamily && (
            <>
              {/* Header Section */}
              <div className="card-header   bg-gradient text-white  " style={{background: '#035d2b',  }}>
                <h6 className="mb-2 opacity-75 text-uppercase small  ">Family</h6>
                <h4 className="mb-0  ">{detailedFamily.family_name}</h4>
              </div>
        
              <div className="card-body p-4x">
                {/* Lineage Grid */}
        
                <div className="d-flex flex-wrap align-items-center gap-3 py-2 px-3 bg-light rounded-3 border">
          {/* Tribe - Always visible */}
          <div className="d-flex align-items-center">
            <small className="text-muted fw-bold text-uppercase me-2" style={{ fontSize: '0.65rem' }}>Tribe:</small>
            <span className="fw-semibold text-dark small">{detailedFamily.tribe_name}</span>
          </div>
        
          {/* Other fields with separators */}
          {[
            { label: 'Sub-Tribe', value: detailedFamily.sub_tribe_name },
            { label: 'Sub-Group', value: detailedFamily.sub_group_name },
            { label: 'Clan', value: detailedFamily.clan_name }
          ].map((item, idx) => item.value && (
            <div key={idx} className="d-flex align-items-center border-start ps-3">
              <small className="text-muted fw-bold text-uppercase me-2" style={{ fontSize: '0.65rem' }}>{item.label}:</small>
              <span className="fw-semibold text-dark small">{item.value}</span>
            </div>
          ))}
        
          {/* Totem as a small pill at the end */}
          {detailedFamily.totem_name && (
            <div className="ms-auto">
              <span className="badge rounded-pill bg-info-subtle text-info border border-info-subtle fw-medium" style={{ fontSize: '0.7rem' }}>
                <i className="bi bi-shield-check me-1"></i> {detailedFamily.totem_name}
              </span>
            </div>
          )}
        </div>
        
        
        
                <hr className="my-4 opacity-25" />
        
                {/* Members/Admins Section */}
                <div className="section-people">
                  <h6 className="fw-bold mb-3 d-flex align-items-center">
                    <span className="me-2 text-primary">●</span> People you may know
                  </h6>
                  <div className="d-flex flex-wrap gap-2">
                  {(detailedFamily?.admin || []).map((admin, idx) => (
  <div 
    key={idx} 
    className="d-inline-flex align-items-center bg-light border rounded-pill px-3 py-2 shadow-sm"
  >
    <div
      className="avatar-sm bg-secondary text-white rounded-circle me-2 d-flex align-items-center justify-content-center"
      style={{ width: '24px', height: '24px', fontSize: '12px' }}
    >
      {admin.name?.charAt(0)}
    </div>

    <span className="text-dark small fw-medium">
      {admin.n_prefix && (
        <span className="text-muted me-1">{admin.n_prefix}</span>
      )}
      {admin.name} {admin.last_name}
    </span>
  </div>
))}
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
                            
        
                            {/* ✅ tighter actions */}
                            
                            <div className="d-flex justify-content-between mt-3">
                            <Link to='/verify-invitation-reject' className="btn btn-light border rounded-3 px-3 py-2">
                            Reject Invitation
                            </Link>
        
                              <Link to="/verify-invitation-info-confirm" 
                              className="btn rounded-3 px-3 py-2 d-inline-flex align-items-center justify-content-center"
                               
                               style={{
                                 minWidth: 120,
                                 background: "linear-gradient(135deg, #74BA54, #2C533D)",
                                 border: "none",
                                 color: "#fff",
                               }}>
                              Next »
                              </Link>
        
                            </div>
        
                         
                        </div>
                      </div>
        
        
        
        
        
        
        
                      <div style={{ height: 8 }} />
                    </div>
                  </div>

             
                                    
          </div>
        </div>


 
      
      </div>
    
  );
}

export default VerifyInvitationInfoUpdate;
